import gql from 'graphql-tag';

export const createGoal = gql`
  mutation CreateGoal($input: GoalInput, $userID: String!) {
    createGoal(input: $input, userID: $userID)
  }
`;

export const addGoalJustification = gql`
  mutation AddGoalJustification(
    $input: GoalJustificationInput
    $userID: String!
  ) {
    addGoalJustification(input: $input, userID: $userID)
  }
`;
